"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactJss = _interopRequireDefault(require("react-jss"));
var _clsx = _interopRequireDefault(require("clsx"));
var _Table = _interopRequireDefault(require("./Table.style"));
var _dec, _class, _class2;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
let Table = (_dec = (0, _reactJss.default)(_Table.default), _dec(_class = (_class2 = class Table extends _react.PureComponent {
  constructor(props) {
    super(props);
    this.tableRef = props.forwardRef || _react.default.createRef();
  }
  getChildContext() {
    const {
      scrolled,
      visibility,
      paddingSize
    } = this.props;
    return {
      scrolled,
      visibility,
      paddingSize
    };
  }
  renderTable(tableClasses, children) {
    const {
      columnSize,
      dataTestId
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("div", {
      ref: this.tableRef,
      className: tableClasses,
      "data-testid": dataTestId
    }, _react.default.Children.map(children, child => _react.default.cloneElement(child, {
      columnSize
    })));
  }
  render() {
    const {
      className,
      classes,
      visibility,
      children,
      scrolled
    } = this.props;
    const tableClasses = (0, _clsx.default)(classes.table, {
      [`${className}`]: !scrolled
    }, {
      hidden: visibility === 'hidden'
    }, {
      disabled: visibility === 'disabled'
    });
    const tableWrapClasses = (0, _clsx.default)(classes.tableWrap, className, {
      hidden: visibility === 'hidden'
    }, {
      disabled: visibility === 'disabled'
    }, {
      scrolled
    });
    return scrolled ? /*#__PURE__*/_react.default.createElement("div", {
      className: tableWrapClasses
    }, this.renderTable(tableClasses, children)) : this.renderTable(tableClasses, children);
  }
}, (0, _defineProperty2.default)(_class2, "childContextTypes", {
  scrolled: _propTypes.default.bool,
  visibility: _propTypes.default.oneOf(['visible', 'disabled', 'hidden']),
  paddingSize: _propTypes.default.oneOf(['small', 'medium'])
}), _class2)) || _class);
Table.defaultProps = {
  visibility: 'visible',
  scrolled: false,
  paddingSize: 'medium',
  columnSize: {}
};
var _default = exports.default = Table;